module.exports = __webpack_public_path__ + "static/media/Intro-after-sprakforstaelse.d609356b.mp3";